import { Component, inject } from '@angular/core';
import { AppInfoService } from '../../services';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-login-entraid',
  templateUrl: './login-entraid.component.html',
  styleUrls: ['./login-entraid.component.scss'],
  imports: [RouterModule],
  standalone: true
})
export class LoginEntraIdComponent {
  public appInfo = inject(AppInfoService);
}

export class LoginEntraIdModule {}
